/*
  定数クラス
*/

const CHAR_NULL = 'null';

/* 申請書類詳細区分 */
const APP_DOCUMENT_DETAIL_FRONT = '10'
const APP_DOCUMENT_DETAIL_DIAGOBAL = '20'
const APP_DOCUMENT_DETAIL_BACK = '30'
const APP_DOCUMENT_DETAIL_FACE_FRONT = '40'
const APP_DOCUMENT_DETAIL_FACE_DIAGOBAL = '50'
/* 処置区分 */
const DEAL_KBN_APPROVAL = '100'
const DEAL_KBN_DENIAL = '200'

/* URL API */
const URL_API_APCP01 = '/api/v1.0/all/app/verifyappfileinfo/add/:documentKbnCd/:documentDetailKbnCd/:receiptNo';
const URL_API_APA100G01 = '/api/v1.0/all/app/verifyappreqest/:accesskey';
const URL_API_APA200P01 = '/api/v1.0/all/app/verifyapp/add';
const URL_API_APA410P01 = '/api/v1.0/all/app/verifyappreqest/:systemId/:receiptNo/verifyappfileinfo/add/:documentKbnCd/:documentDetailKbnCd';


const URL_API_VFA100G01 = '/api/v1.0/login/verify';
const URL_API_VFU100P01 = '/api/v1.0/user/verify/verifyUser/searchconditions';
const URL_API_VFU100P02 = '/api/v1.0/user/verify/verifyUser/:verifyUserId/delete';
const URL_API_VFU200P01 = '/api/v1.0/user/verify/verifyUser/add';
const URL_API_VFU210G01 = '/api/v1.0/user/verify/verifyUser/:verifyUserId';
const URL_API_VFU210P01 = '/api/v1.0/user/verify/verifyUser/:verifyUserId';
const URL_API_VFU220P01 = '/api/v1.0/user/verify/verifyUser/:verifyUserId/pw';

const URL_API_VFV100G01 = '/api/v1.0/user/verify/information';
const URL_API_VFV200P01 = '/api/v1.0/user/verify/receiptApp/searchconditions';
const URL_API_VFV210G01 = '/api/v1.0/user/verify/verifyapps/:receiptNo';
const URL_API_VFV210G02 = '/api/v1.0/user/verify/verifyapps/verifyappdocs/verfyappfiles/:receiptNo/:docDetailKbn';
const URL_API_VFV210P01 = '/api/v1.0/user/verify/verifyapps/:receiptNo/verifydealwirhhistory/dealwith';
const URL_API_VFV210D01 = '/api/v1.0/user/verify/verifyappreruest/:receiptNo/cancel';
const URL_API_VFV210P02 = '/api/v1.0/all/app/verifyappreqest/:receiptNo/add';

const URL_API_ERA100P01 = '/api/v1.0/all/app/verifyappreqest/add';

/*
 *  凍結化
 */
Object.freeze({

});

import Utils from "./utils";
export default {

  CHAR_NULL,

  APP_DOCUMENT_DETAIL_FRONT,
  APP_DOCUMENT_DETAIL_DIAGOBAL,
  APP_DOCUMENT_DETAIL_BACK,
  APP_DOCUMENT_DETAIL_FACE_FRONT,
  APP_DOCUMENT_DETAIL_FACE_DIAGOBAL,

  DEAL_KBN_APPROVAL,
  DEAL_KBN_DENIAL,

  // URL API
  // URL_API_APA410P01,
  URL_API_APA200P01,
  getUrlApiAPCP01: function(documentKbnCd, documentDetailKbnCd, receiptNo) {
    if (Utils.isNullOrEmptyOrUunDef(documentKbnCd)) {
      documentKbnCd = CHAR_NULL;
    }
    if (Utils.isNullOrEmptyOrUunDef(documentDetailKbnCd)) {
      documentDetailKbnCd = CHAR_NULL;
    }
    if (Utils.isNullOrEmptyOrUunDef(receiptNo)) {
      receiptNo = CHAR_NULL;
    }
    let url = "";
    url = URL_API_APCP01.replace(":documentKbnCd", documentKbnCd);
    url = url.replace(":documentDetailKbnCd", documentDetailKbnCd);
    url = url.replace(":receiptNo", receiptNo);
    return url;
  },
  getUrlApiAPA100G01: function(accesskey) {
    if (Utils.isNullOrEmptyOrUunDef(accesskey)) {
      accesskey = CHAR_NULL;
    }
    return URL_API_APA100G01.replace(":accesskey", accesskey);
  },
  getUrlApiAPA410P01: function(systemId, receiptNo, documentKbnCd, documentDetailKbnCd) {
    if (Utils.isNullOrEmptyOrUunDef(systemId)) {
      systemId = CHAR_NULL;
    }
    if (Utils.isNullOrEmptyOrUunDef(receiptNo)) {
      receiptNo = CHAR_NULL;
    }
    if (Utils.isNullOrEmptyOrUunDef(documentKbnCd)) {
      documentKbnCd = CHAR_NULL;
    }
    if (Utils.isNullOrEmptyOrUunDef(documentDetailKbnCd)) {
      documentDetailKbnCd = CHAR_NULL;
    }    
    let url = "";
    url = URL_API_APA410P01.replace(":systemId", systemId);
    url = url.replace(":receiptNo", receiptNo);
    url = url.replace(":documentKbnCd", documentKbnCd);
    url = url.replace(":documentDetailKbnCd", documentDetailKbnCd);    
    return url;
  },
  URL_API_VFA100G01,
  URL_API_VFU100P01,
  getUrlApiVFU100P02: function(verifyUserId) {
    if (Utils.isNullOrEmptyOrUunDef(verifyUserId)) {
      verifyUserId = CHAR_NULL;
    }
    return URL_API_VFU100P02.replace(":verifyUserId", verifyUserId);
  },
  URL_API_VFU200P01,
  getUrlApiVFU210G01: function(verifyUserId) {
    if (Utils.isNullOrEmptyOrUunDef(verifyUserId)) {
      verifyUserId = CHAR_NULL;
    }
    return URL_API_VFU210G01.replace(":verifyUserId", verifyUserId);
  },
  getUrlApiVFU210P01: function(verifyUserId) {
    if (Utils.isNullOrEmptyOrUunDef(verifyUserId)) {
      verifyUserId = CHAR_NULL;
    }
    return URL_API_VFU210P01.replace(":verifyUserId", verifyUserId);
  },
  getUrlApiVFU220P01: function(verifyUserId) {
    if (Utils.isNullOrEmptyOrUunDef(verifyUserId)) {
      verifyUserId = CHAR_NULL;
    }
    return URL_API_VFU220P01.replace(":verifyUserId", verifyUserId);
  },
  
  URL_API_VFV100G01,
  URL_API_VFV200P01,
  getUrlApiVFV210G01: function(receiptNo) {
    if (Utils.isNullOrEmptyOrUunDef(receiptNo)) {
      receiptNo = CHAR_NULL;
    }
    return URL_API_VFV210G01.replace(":receiptNo", receiptNo);
  },
  getUrlApiVFV210G02: function(receiptNo, docDetailKbn) {
    if (Utils.isNullOrEmptyOrUunDef(receiptNo)) {
      receiptNo = CHAR_NULL;
    }
    if (Utils.isNullOrEmptyOrUunDef(docDetailKbn)) {
      docDetailKbn = CHAR_NULL;
    } 
    let url = "";
    url = URL_API_VFV210G02.replace(":receiptNo", receiptNo);
    url = url.replace(":docDetailKbn", docDetailKbn);   
    return url;
  },
  getUrlApiVFV210P01: function(receiptNo) {
    if (Utils.isNullOrEmptyOrUunDef(receiptNo)) {
      receiptNo = CHAR_NULL;
    }
    return URL_API_VFV210P01.replace(":receiptNo", receiptNo);
  },
  getUrlApiVFV210D01: function(receiptNo) {
    if (Utils.isNullOrEmptyOrUunDef(receiptNo)) {
      receiptNo = CHAR_NULL;
    }
    return URL_API_VFV210D01.replace(":receiptNo", receiptNo);
  },
  getUrlApiVFV210P02: function(receiptNo) {
    if (Utils.isNullOrEmptyOrUunDef(receiptNo)) {
      receiptNo = CHAR_NULL;
    }
    return URL_API_VFV210P02.replace(":receiptNo", receiptNo);
  },

  URL_API_ERA100P01,
};
